import React, {
  Dispatch,
  SetStateAction,
  createContext,
  useCallback,
  useContext,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react';

interface IState {
  totalSteps: number;
  currentStep: number;
  isFinalStep: boolean;
}
interface ISelectors {}
interface IActions {
  incrementStep: () => void;
  setTotalSteps: Dispatch<SetStateAction<number>>;
}
export interface IWizard {
  selectors: ISelectors;
  actions: IActions;
  state: IState;
}

// @ts-ignore - we don't need to provide a default context value
export const WizardContext = createContext<IWizard>();
export const useWizard = (): IWizard => useContext(WizardContext);

export const WizardProvider: React.FC = ({ children }) => {
  const [totalSteps, setTotalSteps] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);

  // scroll to the top:
  // - initial render
  // - when the step changes
  useLayoutEffect(() => {
    if (document.body.scrollTop) {
      document.body.scrollTop = 0;
    }
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
  }, [currentStep]);

  const incrementStep = useCallback(() => {
    // don't increment if the current step is equal to the total steps
    // update the isFinalStep once we hit the totalSteps
    setCurrentStep(currStep => {
      if (currStep === totalSteps) {
        return currStep;
      }

      return currStep + 1;
    });
  }, [totalSteps]);

  const isFinalStep = useMemo(() => currentStep === totalSteps, [currentStep, totalSteps]);

  const value: IWizard = {
    state: {
      totalSteps,
      currentStep,
      isFinalStep,
    },
    actions: {
      incrementStep,
      setTotalSteps,
    },
    selectors: {},
  };

  return <WizardContext.Provider value={value}>{children}</WizardContext.Provider>;
};
